export default __webpack_public_path__ + "static/media/hu.b1f0e494.svg";